import React, { useState } from 'react';
import Modal from '../../../BaseComponents/Modal';
import Button from '../../../BaseComponents/Button';
import { deleteCondition, ConditionWithDetails } from '../../../../api/conditions';
import { toast } from 'react-toastify';
import './ConditionModal.scss';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  conditionToDelete: ConditionWithDetails | null;
  onConditionDeleted: () => void;
};

const DeleteConditionModal: React.FC<Props> = ({ 
  isOpen, 
  onClose, 
  conditionToDelete, 
  onConditionDeleted 
}) => {
  const [loading, setLoading] = useState<boolean>(false);

  const onDeleteClick = async () => {
    if (!conditionToDelete) return;
    
    setLoading(true);
    try {
      const deleteResponse = await deleteCondition(conditionToDelete.id);
      
      if (deleteResponse.message && deleteResponse.status !== 'success') {
        toast.error(deleteResponse.message);
        return;
      }
      
      toast.success('Medical condition deleted successfully');
      onConditionDeleted();
      onClose();
    } catch (error) {
      console.log('error :>> ', error);
      toast.error('Cannot delete medical condition with assigned members');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      width="420px"
    >
      <div className="delete-block-container">
        <div className="modal-header">
          <div className="title">Are you sure you want to delete this medical condition?</div>
        </div>

        <div className="submit-btn-wrapper">
          <Button
            text="No"
            onClick={onClose}
          />
          <Button 
            text="Yes" 
            onClick={onDeleteClick} 
            isLoading={loading} 
          />
        </div>
      </div>
    </Modal>
  );
};

export default DeleteConditionModal;
